import { useLocation } from '../../_snowpack/pkg/react-router-dom.js';

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

export default useQueryParams;